// Dependencies
import styledComponents from 'styled-components';

export const Wrapper = styledComponents<any>('div').attrs(props => ({
  className: props.classes,
}))`

`;
